module.exports = "form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\nmat-form-field {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/matrix-dialog/matrix-dialog.component.css
// module id = ./src/app/matrix-dialog/matrix-dialog.component.css
// module chunks = main